/**
 * A helper function to handle the response of an HTTP request.
 * @param response an http Response object
 * @returns a Promise that resolves to the JSON representation of the response
 */
export const _handleResponse = async (response: Response): Promise<any> => {
  if (!response.ok) {
    if (response.status === 400) {
      return Promise.reject(await response.json());
    }

    // Try to parse the response body for a server-provided error message
    // (e.g. 403 returns {"message": "Invalid recaptcha"})
    let errorMessage = response.statusText;
    try {
      const body = await response.json();
      if (body?.message) {
        errorMessage = body.message;
      }
    } catch {
      // response body is not JSON or is empty, fall back to statusText
    }

    throw new Error(errorMessage);
  }

  return response.json();
};
